import { Link } from 'react-router'
import { PageCard, PageFrame } from '#app/components/page-frame.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { PawMark } from '#app/root.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Oyka' },
	{
		name: 'description',
		content:
			'Bigfoot, kleine stapjes: rustige ondersteuning voor zelfstandig wonen, voor het hele gezin.',
	},
]

/**
 * The landing page in the herontwerp language (ADR-027): the same copy as
 * before — including the non-medical-device sentence landing.test.ts pins —
 * on one hairline card with the Onest scale and the single accent.
 */
export default function Index() {
	return (
		<main>
			<PageFrame size="md">
				<PageCard className="text-left">
					<span
						aria-hidden="true"
						className="bg-secondary text-secondary-foreground flex size-14 items-center justify-center rounded-full"
					>
						<PawMark className="size-8" />
					</span>
					<h1 className="mt-5 text-[30px] leading-[1.15] font-extrabold tracking-[-0.02em] sm:text-[36px]">
						Oyka
					</h1>
					<p className="mt-3 text-[18px] leading-snug font-semibold">
						Bigfoot, kleine stapjes: rustige ondersteuning voor zelfstandig
						wonen, voor het hele gezin.
					</p>
					<Button asChild variant="default" size="lg" className="mt-6">
						<Link to="/login">Inloggen</Link>
					</Button>
					<p className="text-muted-foreground mt-6 text-[15px] leading-[1.45]">
						Oyka verbindt de gedeelde agenda, familie-berichten en het
						keukenscherm van je naaste. De familie stuurt een appje door; de
						afspraak verschijnt vanzelf op het scherm in de keuken. Stil als
						alles goed gaat, duidelijk als er iets nodig is.
					</p>
					<p className="text-muted-foreground mt-5 text-[15px] leading-[1.45]">
						Oyka is een organisatiehulpmiddel voor agenda's, herinneringen en
						familie-coördinatie. Het is géén medisch hulpmiddel en geeft geen
						zorg- of gezondheidsadviezen.
					</p>
					<p className="text-muted-foreground border-border mt-8 border-t pt-4 text-[13px] font-semibold">
						<span lang="en">
							Oyka is a calm family-coordination platform for independent
							living. It is an organisational aid, not a medical device.
						</span>
					</p>
				</PageCard>
			</PageFrame>
		</main>
	)
}
